export const STRATEGY_LABELS = {
  wheel: "Wheel",
  earnings: "Earnings",
  tactical_spread: "Tactical Spread",
  tactical_spreads: "Tactical Spread",
  tactical_debit_spread: "Tactical Spread",
  regime_spread: "Regime Spread",
  regime_spreads: "Regime Spread",
  regime_debit_spread: "Regime Spread",
  1: "Wheel",
  2: "Tactical Spread",
  3: "Regime Spread",
  4: "Earnings",
};

const SPREAD_ACTIONS = new Set(["OPEN_DEBIT_SPREAD", "CLOSE_DEBIT_SPREAD"]);
const WHEEL_ACTIONS = new Set(["SELL_PUT", "SELL_CSP", "SELL_CALL", "BUY_TO_CLOSE", "TAKE_PROFIT", "CLOSE"]);

export function normalizeStrategyKey(rawStrategy) {
  const normalized = String(rawStrategy || "").trim().toLowerCase();
  if (!normalized) return null;
  if (["tactical_spread", "tactical_spreads", "tactical_debit_spread"].includes(normalized)) return "tactical_spread";
  if (["regime_spread", "regime_spreads", "regime_debit_spread"].includes(normalized)) return "regime_spread";
  if (normalized === "wheel") return "wheel";
  if (normalized === "earnings") return "earnings";
  return null;
}

export function resolveStrategyLabel(meta, strategyValue, action) {
  const backendLabel = meta?.strategy_label || meta?.strategy_chip;
  if (backendLabel) return backendLabel;

  const rawCandidates = [
    meta?.strategy_key,
    meta?.strategy,
    meta?.selected_strategy,
    strategyValue,
  ];

  for (const candidate of rawCandidates) {
    const normalized = normalizeStrategyKey(candidate);
    if (normalized && STRATEGY_LABELS[normalized]) return STRATEGY_LABELS[normalized];
    if (candidate != null && STRATEGY_LABELS[candidate]) return STRATEGY_LABELS[candidate];
  }

  if (SPREAD_ACTIONS.has(action)) return "Tactical Spread";
  if (WHEEL_ACTIONS.has(action)) return "Wheel";
  return null;
}

// Governance states that restrict execution regardless of auto_manage preference.
const _GOVERNANCE_CLOSE_ONLY  = new Set(["disabled"]);
const _GOVERNANCE_PREVIEW_ONLY = new Set(["experimental"]);
const _GOVERNANCE_AUTO_QUALIFIED = new Set(["approved", "pilot", "degraded"]);

export function resolveAutomationDisplay(record = {}) {
  const governanceState = record.governance_state || record.meta?.governance_state || null;

  // Governance-overridden states take precedence over user preference
  if (governanceState && _GOVERNANCE_CLOSE_ONLY.has(governanceState))  return "close-only";
  if (governanceState && _GOVERNANCE_PREVIEW_ONLY.has(governanceState)) return "preview-only";

  const isAuto =
    typeof record.auto_manage === "boolean"
      ? record.auto_manage
      : ["auto"].includes(
          String(record.automation_mode || record.meta?.automation_mode || "").toLowerCase()
        );

  if (!isAuto) return "manual";

  // Auto + governance qualifier
  if (governanceState && _GOVERNANCE_AUTO_QUALIFIED.has(governanceState)) {
    return `auto-${governanceState}`;
  }

  return "auto";
}

export function applyAutomationOptimisticUpdate(collection, matcher, nextValue, fieldName = "auto_manage") {
  return collection.map((item) => (matcher(item) ? { ...item, [fieldName]: nextValue } : item));
}
